export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    photo: null,
    testimonial: {
      id: null,
      name: '',
      photo: '',
      body: '',
      location: '',
    },
  }
}
